<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getDepartments");

  },
  computed: {
    departments() {
      return  this.$store.state.lookups.departments;
    }
   
  },
  data() {
    return {
      vm: {
        serviceName: null,
        price: null,
        departmentId: null
      },
    };
  },
  methods: {
    confirm() {
      this.$store
        .dispatch("services/add",  this.vm )
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
  
    back() {
      this.$emit("back");
    },
  },
};
</script>